import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  dotsMenuIcon: ({ headerBackground }: { headerBackground: boolean }) => ({
    width: 40,
    height: 40,
    padding: theme.spacing(1.5),
    marginRight: theme.spacing(2),

    "& svg": {
      width: "100%",
      height: "100%",

      "& g, & path": {
        fill: headerBackground ? theme.palette.common.white : "#757575",
      },
    },
  }),
  tooltipContainer: {
    background: theme.palette.common.white,
    borderRadius: theme.spacing(3),
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: theme.spacing(1, 2),
  },
  imageBox: {
    width: 40,
    height: 40,

    "& img": {
      borderRadius: "50%",

      width: "100%",
      height: "100%",
    },
    marginBottom: theme.spacing(0.5),
  },
  tooltipAppItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: theme.palette.grey[700],
    cursor: "pointer",
  },
  tooltipItemLink: {
    textDecoration: "none",
    color: "inherit",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1),
    borderRadius: theme.spacing(3),
    background: theme.palette.common.white,
    transition: "background 0.5s",

    "&:hover": {
      background: "rgba(117, 117, 117, 0.2)",
    },
  },
}));
